import React, { Component } from 'react';

import ExpandableContent from '../ExpandableContent/ExpandableContent';
import classNames from 'classnames';
import styles from './StoryFeedItem.module.scss';
import { withTranslation, WithTranslation } from 'next-i18next';
import { getImageUrl, isUsingFallback, size } from '@/utils/attachment';
import ImageLoader from '@/components/features/posts/ImageLoader/ImageLoader';
import Author from '@/components/features/posts/Author/Author';
import { formatPostedAtDate } from '@/utils/post-date';
import PostInfo from '@/components/features/posts/PostInfo/PostInfo';
import { LikeButton } from '@/components/features/posts/SocialBar/LikeButton/LikeButton';
import SocialBar from '@/components/features/posts/SocialBar/SocialBar';
import { getCollection } from '@/utils/social-media-share-links';
import { useUser } from '@/hooks/useUser';
import { withUser } from '@/components/shared/utilities/WithUser/WithUser';

interface IStoryFeedItemProps extends WithTranslation, ReturnType<typeof useUser> {
	data: any;
}

class StoryFeedItem extends Component<IStoryFeedItemProps> {
	constructor(props: IStoryFeedItemProps) {
		super(props);
	}

	render() {
		const { data, user, t } = this.props;
		const slug = data.slug || data.id;
		const isUsingFallbackImg = isUsingFallback(data.image, size.MEDIUM);

		const storyFeedImageClassNames = classNames(styles.storyFeedImage, {
			[styles.storyFeedImageDefault]: isUsingFallbackImg,
		});

		return (
			<div className={styles.storyFeed} key={data.id}>
				<div className={styles.storyFeedInner}>
					<ImageLoader
						src={getImageUrl(data.image, size.MEDIUM)}
						preloader={getImageUrl(data.image, size.PRELOADER)}
						className={storyFeedImageClassNames}
					/>
					<div className={styles.storyFeedContent}>
						<div className={styles.storyFeedTextWrapper}>
							<div className={styles.storyFeedType}>
								<Author
									initials={data.initials}
									label={`${t('posted')} ${formatPostedAtDate(data.createdAt)}`}
									invert
								/>
							</div>
							<h2 className={styles.storyFeedTitle}>{data.title}</h2>
							<PostInfo className={styles.storyFeedInfo} data={data} />
							<ExpandableContent className={styles.storyFeedDescription} content={data.content} isLinkify />
						</div>
					</div>
					<div className={styles.storyFeedFooter}>
						{user ? <LikeButton faveable={data} /> : null}

						<SocialBar
							shareLinksCollection={getCollection('/feed/' + slug, data)}
							menuContainerClassName={styles.storyFeedSocialMenuContainer}
							menuCloseClassName={styles.storyFeedSocialMenuClose}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(withUser(StoryFeedItem));
